import { uuidRegex } from "@l2r-front/l2r-utils"

import { APP_SAFETY } from "../constants/appSafety"
import { MODULE_INCIDENTS, MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../constants/modules"

export const getModulesBreadcrumb = (searchUrlparams, location) => {
    const eventId = location.pathname.match(uuidRegex)?.[0]
    searchUrlparams.delete("tab-incident-details")

    const searchUrl = searchUrlparams ? `?${searchUrlparams}` : ""

    return [
        {
            path: `/:network/${APP_SAFETY}/${MODULE_INCIDENTS}/:eventId/analysis`,
            newPath: `${APP_SAFETY}/${MODULE_INCIDENTS}/${eventId}`,
        },
        {
            path: `/:network/${APP_SAFETY}/${MODULE_INCIDENTS}/:eventId`,
            newPath: `${APP_SAFETY}/${MODULE_INCIDENTS}${searchUrl}`,
        },
        {
            path: `/:network/${APP_SAFETY}/${MODULE_INCIDENTS}/filters`,
            newPath: `${APP_SAFETY}/${MODULE_INCIDENTS}${searchUrl}`,
        },
        {
            path: `/:network/${APP_SAFETY}/${MODULE_RISK_ZONES}/:road`,
            newPath: `${MODULE_RISK_ZONES}?${searchUrl}`,
        },
        {
            path: `/:network/${APP_SAFETY}/${MODULE_RISK_ZONES}/:road/:riskZoneUuid`,
            newPath: `${MODULE_RISK_ZONES}/:road`,
        },
        {
            path: `/:network/${APP_SAFETY}/${MODULE_SPEEDINGS}/:road`,
            newPath: `${MODULE_SPEEDINGS}?${searchUrl}`,
        },
        {
            path: `/:network/${APP_SAFETY}/${MODULE_SPEEDINGS}/:road/:speedingUuid`,
            newPath: `${MODULE_SPEEDINGS}/:road`,
        },
    ]
}